/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LicensedLawyer {
  Myself = "Myself",
  SomeoneElse = "SomeoneElse",
}

export const LicensedLawyerDisplay: Record<LicensedLawyer, string> = {
  [LicensedLawyer.Myself]: "Myself",
  [LicensedLawyer.SomeoneElse]: "Someone Else",
};
